module.exports = __webpack_public_path__ + "img/PL08805.10c70571.png";